import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: QueryParams) => {
    const url = `api/bo/getCustomClusterList?customerId=${params}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useQueryClustersSearchWordsList = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['clustersSearchWordsList', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params),
        staleTime: 300000,
    });
};

type QueryParams = number | undefined;

interface QueryResponse {
    clusterName: string;
    id: number;
}
